import { useRef, useState } from 'react';
import { createExpense } from '@/modules/accounting/services';
import { getInitialExpenseForm } from '@/modules/accounting/utils';
import { toast } from '../../../../shared/hooks/use-toast';

export function useCreateExpenseForm({ expenses, onCreate }) {
  const [isOpen, setIsOpen] = useState(false);
  const [form, setForm] = useState(getInitialExpenseForm());
  const [isSubmitting, setIsSubmitting] = useState(false);
  const mutexRef = useRef(false);
  const idempotencyKeyRef = useRef('');

  function resetForm() {
    setForm(getInitialExpenseForm());
  }

  function openDialog() {
    idempotencyKeyRef.current = '';
    setIsOpen(true);
  }

  function closeDialog() {
    setIsOpen(false);
    resetForm();
  }

  function updateField(field, value) {
    setForm((prev) => ({
      ...prev,
      [field]: value,
      ...(field === 'recipientType' && value !== 'STAFF' ? { staffId: '', staffIds: [] } : {}),
      ...(field === 'recipientType' && value !== 'SUPPLIER' ? { supplierId: '', supplierIds: [], supplierName: '' } : {}),
    }));
  }

  async function submit() {
    if (mutexRef.current) return false;
    mutexRef.current = true; setIsSubmitting(true);
    let result;
    if (!idempotencyKeyRef.current) idempotencyKeyRef.current = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
    try { result = await createExpense(form, idempotencyKeyRef.current); } finally { mutexRef.current = false; setIsSubmitting(false); }
    if (!result.ok) {
      toast({ title: 'Uscita non creata', description: result.message, variant: 'destructive' });
      return false;
    }

    await onCreate(result.data.expense);
    idempotencyKeyRef.current = '';
    closeDialog();
    return true;
  }

  return {
    isOpen,
    form,
    openDialog,
    closeDialog,
    updateField,
    submit,
    isSubmitting,
  };
}
